import React, { useMemo, useState } from 'react'
import { useDropzone } from 'react-dropzone'

// components
import {
  CCol,
  CFormLabel,
  CFormInput,
  CImage,
  CButton,
  CFormText
} from '@coreui/react-pro'

// icons
import UploadImageIcon from '../../../assets/icons/UploadImageIcon.png'

// styling
import { styleButtonVars4 } from '../../custom-styles/buttonStyles'
import {
  baseStyle,
  focusedStyle,
  acceptStyle,
  textUploadDropZoneStyle1,
  textUploadDropZoneStyle2
} from '../../custom-styles/containerStyle'

const FormFileUpload = ({
  colSize,
  inputLabel,
  className,
  name,
  value,
  handleFileOnDrop,
  handleFileInput,
  feedbackInvalid,
  invalid,
  multiple,
  maxFiles = 12,
  isSpesificType = false,
  typeFile
}) => {
  const [fileErrors, setFileErrors] = useState("");
  
  let acceptedFile = {
    'image/*': [],
    'video/*': [],
    'application/pdf': [],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
    'application/msword': [],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
    'application/vnd.ms-excel': []
  }

  if (isSpesificType) {
    if (typeFile == 'image') {
      acceptedFile = {
        'image/*': []
      }
    } else if (typeFile == 'video') {
      acceptedFile = {
        'video/*': []
      }
    } else if (typeFile == 'document') {
      acceptedFile = {
        'application/pdf': [],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
        'application/msword': [],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
        'application/vnd.ms-excel': []
      }
    }
  }

  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept
  } = useDropzone({
    accept: acceptedFile,
    maxFiles: maxFiles,
    maxSize: 50000000,
    multiple: true,
    onDrop: (acceptedFiles, fileRejections) => {
      fileRejections.forEach((file) => {
        file.errors.forEach((err) => {
          if (err.code === "file-too-large") {
            setFileErrors(`File too large`);
          }

          if (err.code === "file-invalid-type") {
            setFileErrors(`Invalid file type`);
          }

          if (err.code === 'too-many-files') {
            setFileErrors(`Only have upload ${maxFiles} files`);
          }
        });
      });
      handleFileOnDrop(acceptedFiles, name)
    }
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isFocused ? focusedStyle : {}),
    ...(isDragAccept ? acceptStyle : {})
  }), [
    isFocused,
    isDragAccept
  ]);

  return (
    <CCol lg={colSize} className={className}>
      <div className='d-grid gap-2 d-md-flex align-items-center'>
        <CFormLabel>
          {inputLabel}
        </CFormLabel>
      </div>
      <div {...getRootProps({ style })}>
        <CImage fluid src={UploadImageIcon} className="mt-4" />
        <p className="my-3" style={textUploadDropZoneStyle2}>Drag &amp; Drop Files Here</p>
        <p className="my-2" style={textUploadDropZoneStyle1}><i>or</i></p>
        <CFormInput
          id="upload_file"
          className="position-absolute invisible"
          name={name}
          type="file"
          value={value}
          onChange={(e) => handleFileInput(e, name)}
          feedbackInvalid={feedbackInvalid}
          invalid={invalid}
          multiple={multiple}
          accept='image/*,video/*,application/*'
          {...getInputProps()}
        />
        <label className="my-3" htmlFor="upload_product_images">
          <CButton style={styleButtonVars4}>Choose File(s)</CButton>
        </label>
        {fileErrors && (
          <CFormText className='error-text-field'>
            {fileErrors}
          </CFormText>
        )}
        <p className="my-2" style={textUploadDropZoneStyle1}>Maximum file size 50MB per file</p>
        <p style={textUploadDropZoneStyle1}>Supported file type: {isSpesificType ? typeFile == 'image' ? '.jpg .jpeg .png' : typeFile == 'video' ? '.mp4' : typeFile == 'document' ? '.pdf .docx .doc .xlsx .xls' : '' : '.jpg .jpeg .png .mp4 .pdf .docx .doc .xlsx .xls'}</p>
      </div>
    </CCol >
  )
}

export default FormFileUpload
